import {Component} from "@angular/core";
import * as user from "user";

@Component({
	selector: "device-management",
	template: `
		<div class="devicemanagement">
			<div>
				<secondary-navigation></secondary-navigation>
			</div>

			<div *ngIf="user.signedIn" class="layout-constrained">
				<cart-fulfillment-banners>
				</cart-fulfillment-banners>
			</div>

			<div class="layout-constrained">
				<router-outlet></router-outlet>
			</div>
		</div>

		<error-modal-outlet></error-modal-outlet>
	`,
})
export class DeviceManagementComponent {
	user: any;

	constructor() {
		this.user = user;
	}
}
